import { z } from "zod";
export const BugCoverageParams = z.object({
    ticketId: z.string().min(1),
});
export const SupportingTest = z.object({
    testId: z.string(),
    relevance: z.enum(["high", "medium", "low"]),
    why: z.string(),
});
export const BugCoverageResponse = z.object({
    ticketId: z.string(),
    covered: z.enum(["yes", "partial", "no"]),
    reasoning: z.string(),
    supportingTests: z.array(SupportingTest),
    gapDescription: z.string().nullable(),
    suggestedTestName: z.string().nullable(),
    generatedAt: z.string().datetime(),
    modelUsed: z.string(),
});
//# sourceMappingURL=bug-coverage.js.map